/* eslint-disable max-len */

export default {
  lang: 'Korean',
  homeScreen: {
    title: '캐나다 스페셜리스트 프로그램, 저희와 함께 해 주세요',
    stayConnected: '소통하기',
    comingSoon: '곧 공개 예정',
    messages: '메시지',
  },
  announcements: {
    gb: {
      message:
        'Not receiving our news? Please register here to ensure you get all the latest information on Destination Canada FAM trips and training events.',
      weblink: 'http://eepurl.com/iicqNz',
      img: '',
    },
  },
  loginScreen: {
    version2: {
      homeTitle: '시스템에서 회원님의 기존 프로필을 찾을 수 있는지 확인해 보겠습니다.',
      homeTitleSub: '교육 프로그램에 로그인할 때 일반적으로 사용하는 이메일 주소를 입력합니다.',
      noAccount: '계정을 찾을 수 없습니다({이메일}). 다른 이메일로 시도하거나 지금 계정을 만드세요.',
      continueButton: '계속',
      success: '계정을 성공적으로 업데이트했습니다! 곧 홈 페이지로 리디렉션됩니다.',
      successNewAccount: '등록을 완료하면 계정 확인을 위한 확인 이메일을 받게 됩니다.',
      loginButton: '로그인',
      matchFound: '일치하는 항목을 찾았습니다. 계속하려면 비밀번호를 입력하세요.',
      magicLink: '이메일에 포함된 링크를 통해 로그인합니다:',
      magicLinkButton: '매직 링크 요청하기',
      magicLinkTitle: '즉시 로그인할 수 있는 직접 링크를 이메일로 전송받으세요.',
      otherEmailButton: '제출',
      title: '개인 프로필과 연락처 정보가 입력되므로 잠시 시간을 내어 아래의 모든 정보를 입력해 주세요.',
      titleIndustry: '개인 프로필과 연락처 정보가 입력되므로 잠시 시간을 내어 아래의 모든 정보를 입력해 주세요.',
      register: '계정 만들기',
      agent: '여행 어드바이저',
      visitor: '업계 방문자',
      step1: '1단계: 사용자 유형',
      step2: '2단계: 계정 만들기',
      step3: '3단계: 프로필 만들기',
      milesAttack: 'Do you have a Miles Attack code? Indicate the 4 letters',
      marketingOptIn: '이 프로그램의 여행 무역 팀과 계속 연락하고 싶지 않으세요?',
      optIn: '예, 관심 있습니다',
      optOut: '관심 없음',
      step2Sub1: '귀사에 대해 알려주세요',
      step2Sub2: '귀사의 비즈니스에 대해 알려주세요.',
      privacyHead: '커뮤니케이션 기본 설정',
      privacySub:
        '아래 확인란을 선택하여 공급업체의 여행사 팀으로부터 중요한 커뮤니케이션(상품 업데이트 및 공지사항, 보상, 인센티브, FAM 등)과 여행사 네트워킹 및 영업 지원 이니셔티브를 트래프로 모바일에서 받아보시기 바랍니다.',
      privacy: '당사는 사용자의 개인정보를 보호하며 사용자의 신뢰를 판매, 오용 또는 배신하지 않습니다.',
      store: '앱 스토어에서 이 프로그램을 쉽게 다운로드할 수 있습니다:',
      powered: '제공처',
      toastMessage: {
        forgotSuccess: '비밀번호 재설정 링크를 이메일로 보내드렸습니다! 10초 후 로그인 페이지로 리디렉션됩니다.',
        emailNotExisting: '입력하신 이메일 주소가 존재하지 않습니다.',
        magicLinkMessage: '잠시만요, 지금 로그인하는 중입니다.',
        magicLinkError:
          '데이터베이스에서 회원님의 계정을 찾을 수 없습니다. 수동으로 로그인해 주세요. 10초 후에 리디렉션됩니다.',
        magicLinkError1:
          '유효한 토큰을 찾을 수 없습니다. 로그인하거나 새로운 매직 링크를 요청해 주세요. 이 문제가 지속되면 info@travpromobile.com 으로 문의하시기 바랍니다.',
        magicLinkError2:
          '데이터베이스에서 회원님의 계정을 찾을 수 없습니다. 수동으로 로그인해 주세요. 10초 후에 리디렉션됩니다.',
        magicLinkSuccess: '이메일{이메일}에서 이메일을 확인하세요. 로그인할 수 있는 매직 링크가 있습니다.',
        magicLinkErrorWait: '매직링크 요청 사이에는 5분 정도 기다려 주세요.',
        emailNotFoundError:
          '입력하신 이메일 주소를 기록에서 찾을 수 없습니다. 철자가 틀렸는지 확인하거나 계정을 새로 만드세요.',
      },
      errors: {
        zipCodeNotFound: '우편번호를 찾을 수 없습니다, 다시 시도하세요',
        zipCodeOnlyNumbers: '우편번호는 숫자만 포함할 수 있습니다.',
        password: '비밀번호를 입력하세요.',
        passwordNotMatching: '입력한 비밀번호가 일치하지 않습니다.',
        passwordTooShort: '비밀번호는 8자 이상이어야 합니다.',
        emailExists:
          '이 이메일 주소는 이미 존재하거나 유효하지 않습니다. 다른 이메일 주소로 시도하거나 계정에 로그인하세요.',
        fillInAllFields: '필수 입력란을 모두 기입해 주세요.',
        fillInEmail: '이메일을 입력해 주세요.',
        emailNotExisting: '입력하신 이메일 주소가 존재하지 않습니다.',
      },
      fields: {
        forgotSubCopy: '비밀번호를 잊어버려서 변경하고 싶으신가요?',
        forgotSubCopy2:
          '비밀번호를 완전히 우회하고 싶으신가요? 자동으로 프로그램에 로그인할 수 있는 매직 링크가 포함된 이메일을 보내드립니다.',
        city: '도시',
        companyName: '회사 이름',
        role: '귀하의 역할',
        description: '귀사의 비즈니스를 가장 잘 설명하는 것은 무엇인가요?',
        country: '국가',
        password: '비밀번호',
        passwordRegister: '비밀번호 선택(최소 8자)',
        passwordConfirm: '비밀번호 확인',
        firstName: '이름(제공됨)',
        lastName: '성(가족)',
        agency: '대행사 이름',
        title: '역할(하나 선택)',
        company: '회사 이름',
        select: '아래에서 옵션을 선택하세요.',
        state: '상태',
        province: '시/도/지역/주',
        zipCode: '우편 번호',
        postalCode: '우편 번호',
        affiliate: '주요 대행사 소속은 어느 그룹인가요?',
        hostAgency: '호스트 에이전시?',
        executive: '임원',
        management: '관리',
        marketing: '마케팅',
        sales: '판매',
        coordinator: '코디네이터',
        opt: '이 프로그램의 여행 무역 팀과 계속 연락하여 업데이트를 받아보세요.',
        optMarketing: '유사한 프로그램 및 이벤트와 관련하여 트래블프로와 계속 소통하세요.',
        retail: '소매점 매장 전면',
        home: '재택 근무 상담원',
        independent: '독립 계약자',
        host: '호스트 대행사',
        call: '콜센터 또는 웹 기반 대행사',
        other: '기타',
        describes: '귀하와 귀하의 에이전시의 비즈니스를 가장 잘 설명하는 것은 무엇인가요?',
        milesAttack: 'Code Miles Attack (facultatif)',
      },
    },
    title: '여행업 종사자 교육 및 영업 지원 프로그램',
    welcome: {
      headerTop: '캐나다 스페셜리스트 프로그램에',
      headerBottom: '오신 것을 환영합니다.',
    },
    sellingPoints: {
      0: '원하는 시간과 장소에서 참여가능한 교육과정',
      1: '캐나다 스페셜리스트 프로그램 수료증 제공',
      2: '영업활동에 사용할 수 있는 프레젠테이션 컨텐츠 제공',
      3: '효과적인 캐나다 여행 홍보자료',
      4: '여행전문가를 위한 팁과 프로모션',
      5: '실시간으로 확인 가능한 상품 안내',
      6: '캐나다 최신 여행정보 및 업데이트',
    },
    emailPrompt: '',
    tAndC: {
      agree: '계속 진행하면 ',
      privacyPolicy: '개인정보 보호정책',
      and: ' 과 ',
      termsConditions: '이용약관',
      termsConditions2: '에 동의한 것으로 간주됩니다',
    },
    forgot: ' 비밀번호 재설정',
    fields: {
      select: '아래 옵션 선택',
      country: '국가',
      forgot: '비밀번호를 잊으셨나요? 아래 버튼을 클릭하면 비밀번호를 재설정할 수 있는 이메일이 전송됩니다.',
      agency: '대행사',
      email: '이메일',
      password: '암호',
      passwordConfirm: '암호 확인',
      firstName: '이름',
      lastName: '성',
      agencyName: '대행사 이름',
      stateProvince: '시/도',
      required: '필수 항목',
      invalidEmail: '유효하지 않은 이메일 주소',
      opt: '관련 정보를 보내 드립니다! 예, 소식, 이벤트, 인센티브, FAM을 비롯해 캐나다 관광청이 보내 주는 다양한 관련 정보를 받고 싶습니다!',
    },
    noAgent: {
      noAgentButton: '저는 여행사 직원이 아닙니다.',
      title: '캐나다 스페셜리스트 프로그램에 관심을 가져 주셔서 감사합니다.',
      messageWeb:
        '캐나다 스페셜리스트 프로그램은 여행업 종사자를 위한 웹사이트입니다. 캐나다 여행에 대해 좀 더 자세히 알아보고 싶으시다면, 캐나다관광청 홈페이지를 방문해 주시기 바랍니다.',
      messageMobile:
        "이 앱의 일부 콘텐츠는 여행업 종사자를 위한 정보이지만 '계속(Continue)'을 누르면 이 앱이 제공하는 미리보기를 확인할 수 있습니다.",
      continue: '계속',
      visitWebsite: '캐나다관광청',
    },
    newUser: '신규 사용자',
    register: '회원가입',
    registered: '이미 등록되어 있는 이메일입니다',
  },
  welcomeScreen: {
    title: '캐나다 스페셜리스트 프로그램에 오신 것을 환영합니다.',
    helloUser: '{{name}} 님 안녕하세요',
    hello: '안녕하세요,',
    fromAgency: '{{agency}} 소속',
    notUser: '{{name}} 님이 아니신가요?',
    introOnline: '온라인에서 바로 교육을 받거나 미리 로드해둔 콘텐츠를 언제든 오프라인으로 확인할 수 있습니다!',
    introOffline: '최신 버전이 이미 로드되어 있습니다. 언제 어디서나 교육 또는 판매를 시작하세요!',
    startTraining: '학습 시작하기',
    continueTraining: '계속 학습하기',
    graduated: '축하드립니다!',
    downloader: {
      preload: '미리 로드',
      stop: '중지',
      init: '초기화 중...',
      lastUpdate: '마지막 업데이트: ',
    },
  },
  trainingScreens: {
    completedBase: '축하합니다. 캐나다 전문가 인증을 받으셨습니다.',
    allUnlocked: '모든 챕터의 잠금을 해제하셨습니다!',
    certificate: '인증서',
    chapter: '챕터',
    chapterComplete: '완료!',
    choose: '답변을 선택해 주세요',
    confirm: '답변 확인',
    continue: '계속',
    welcome:
      '캐나다 스페셜리스트가되기 위한 교육과정을 완료할 때마다 여러분께 포인트가적립되며, 오른 쪽 막대 바에 보이는 브론즈, 실버, 골드 레벨로 여러분의 현재 이수 상황을알려 드립니다.',
    courseComplete: '교육 과정 완료!',
    durationInMinutes: '{number}분',
    endReached: '완료 단계입니다',
    essential: '기초과정',
    essentialSub: '기본과정의 모든 챕터들을 완료하시면 브론즈 등급이 됩니다. ',
    message: '{count}개의 STAR 메시지',
    messagePlural: '{count}개의 STAR 메시지',
    percentageComplete: '{number}% 완료',
    restart: '다시 시작',
    retainEnd: '상단의 막대를 사용하여 이 챕터를 탐색하거나 뒤로 가기 버튼을 눌러서 개요 부분으로 돌아갈 수 있습니다.',
    retry: '다시 시도해 보세요',
    skip: '돌아가기 >',
    viewAllTitle: '학습 팁!',
    viewAll:
      '여러분이 이 과정을 충분히 이해하실 수 있도록 추가정보, 지도, 비디오 등이 보충자료로 준비되어 있으니 아이콘을 클릭하여 꼭 확인하시기 바랍니다.',
    specialization: '전문 모듈',
    specializationSub: '실버 등급의 캐나다 관광 전문가가 되려면 이 모듈을 완료해 주세요',
    start: '시작하기',
    review: '검토하기',
    status: '현재 등급:',
    tip: '각 단계의 모듈을 완료하여<br />등급을 달성해 보세요. <br />모든 모듈을 완료하여<br />골드 등급의 캐나다 관광 전문가가 되어 보세요!',
    trouble: '도움이 필요하신 것 같습니다. 이전 페이지의 콘텐츠를 검토하고 다시 시도해 주세요.',
    unlock: '챕터 {number}완료 후 잠금이 해지됩니다.',
    unlockSubtitle: '체험과정을 모두 마친 후 잠금이 해제됩니다.',
    unlockFoundation: '기초과정완료후잠금이해제됩니다.',
    watchListenRead: '더보기',
  },
  newTrainingFlow: {
    tip: '팁: 각 단계의 모듈을 완료하여 등급을 달성할 수 있습니다.  모든 모듈을 완료하여 골드 등급의 캐나다 관광 전문가가 되어 보세요!',
    essentialModules: '필수 챕터',
    finishBronze: '브론즈 등급의 캐나다 관광 전문가가 되려면 이 모듈을 완료해 주세요',
    specializationModules: '전문 모듈',
    finishSilver: '실버 등급의 캐나다 관광 전문가가 되려면 이 모듈을 완료해 주세요',
    partnerModules: '파트너 모듈',
    finishGold:
      '지식을 더 높은 수준으로 업그레이드하고 완료한 각 지방, 영토 또는 도시 챕터마다 배지를 획득하세요. 29개의 전체 챕터 중 10개를 완료하면 GOLD 상태를 획득합니다. 29개의 전체 챕터 중 22개를 완료하면 최고의 전문가 상태, PLATINUM에 도달합니다!',
    currentStatus: '현재 등급',
    pointsToLevel: '{pointsToLevel} {points}만 더 모으면 ',
    reachedRanking: '{rank} 등급이 될 수 있습니다!',
    outOf: '{points} XP/',
    pointsToRank: '{pointsToLevel} XP가 있어야 ({rank}) 등급이 될 수 있습니다',
  },
  popUp: {
    congratulations: 'CONGRATULATIONS!',
    bronze:
      '잘 하셨어요! 캐나다의 필수 요소에 대한 모든 것을 배웠고 BRONZE 등급을 획득했습니다. 다음으로 방문자가 이곳에서 경험할 수 있는 다양한 유형의 경험을 살펴보겠습니다.',
    silver:
      '축하해요! The Foundation 및 The Experience의 모든 모듈을 성공적으로 완료하여 Certified Canada Specialist로 학위를 취득했습니다. 또한 SILVER 등급을 획득했으며 아래의 주, 준주 및 도시 섹션으로 진행하여 GOLD 및 그 이상으로 갈 준비가 되었습니다. 앞으로도 힘써주세요!',
    gold: '잘했어! 10개의 지방, 영토 및 도시 모듈을 성공적으로 완료했으며 이제 GOLD 상태를 획득했습니다. 12개를 더 완료하기로 선택하면 완전한 PLATINUM 수준의 캐나다 스페셜리스트가 됩니다!',
    platinum:
      '축하해요!! 귀하는 인증된 캐나다 전문가로서 최고 수준의 자격인 PLATINUM 등급을 획득하셨습니다. 캐나다 판매에 대한 모든 노력과 파트너십에 감사드립니다.',
    platinumWithLink: {
      start:
        'You have just achieved PLATINUM status as a Canada Specialist. You are truly at the top of the class now, well done! You have earned some rewards for your hard work. Click',
      end: 'to visit your Achievements Dashboard and learn how to redeem exclusive PLATINUM deals and offers from our partners.',
      link: 'HERE',
    },
  },
  points: {
    pointsToLevel: '{pointsToLevel} {points}만 더 모으면 {rank} 등급이 될 수 있습니다!',
    outOf: '{points} XP/',
    unit: 'XP',
    pointsToRank: '{pointsToLevel}XP가 있어야 ({rank}) 등급이 될 수 있습니다',
    complete: {
      chapter: '완료!',
      'intro-chapter': '소개 챕터 완료!',
      'sub-app': 'SubApp 완료!',
      rewards: '리워드 완료!',
      multi: '포인트를 모아야 합니다!',
    },
    completed: '{completed}/{total} 완료',
  },
  nav: {
    achievements: '성과',
    home: '홈',
    train: '프로그램',
    learn: '프로그램',
    retain: '다시보기',
    directory: '안내 자료',
    showRoom: '주요 호텔',
    showcases: '주요 호텔',
    promote: '자료실',
    sell: '유용한 정보',
    info: '정보',
    rewards: '리워드',
    media: '미디어',
    favorites: '즐겨찾기',
    contact: '문의',
    reportCard: '수료증 보기',
    accountSettings: '계정 설정',
    messages: '메시지',
    search: '검색',
  },
  contentHeaders: {
    train: '캐나다 스페셜리스트 프로그램',
    retain: '다시보기',
    subapps: '캐나다 여행전문가 과정',
    maintrainings: '기초과정',
    subtrainings: '체험과정',
  },
  pageDescriptions: {
    train: '캐나다 여행전문가가 되어 보세요!',
    showroom: '',
    retain:
      '학습한 내용을 기억하고 영업 활동 관련 지원을 받을 수 있는 최적의 자원입니다. 사용하는 장치에 상관없이 언제 어디서나 상품에 대한 질문에 능숙하게 답하고 즉석에서 영업 프레젠테이션을 진행할 수 있습니다.',
    promote: '다양한 자료를 활용하여 여러분의 잠재고객과 캐나다 여행에 대한 대화를 시작해 보세요.',
    sell: '고객 상담에 도움이 되는 유용한 정보를 활용해 보세요.',
    favorites: '즐겨찾기에 추가한 개인 콘텐츠를 확인해 보세요',
    search: '모든 콘텐츠 살펴보기',
    subapps:
      '캐나다 13개의 주와 준주, 16개의 도시과정을 학습하여 더 전문적인 지식을 쌓고 각 과정별 배지를 획득해보세요. 29개의 전체 과정 중 10개를 완료하면 골드레벨을, 추가로 12개를 더 완료하면 캐나다 최고 전문가레벨인 플래티늄이 됩니다.',
    maintrainings: '기본 모듈을 완료하여 졸업장을 받으세요.',
    subtrainings:
      '캐나다의 놀라운 여행지와 즐길 거리를 모두 완료하시면 실버 등급이 되며, 캐나다 여행전문가에 가까워집니다.',
  },
  general: {
    website: 'https://kr-keepexploring.canada.travel/',
    forgot: '암호를 잊으셨나요?',
    next: '다음',
    yes: '예',
    no: '아니요',
    previous: '이전',
    submit: '제출',
    register: '회원가입',
    back: '뒤로',
    close: '닫기',
    page: '페이지',
    search: '검색',
    logIn: '로그인',
    logOut: '로그아웃',
    viewItem: '{type} 보기',
    imageNotFound: '이미지를 찾을 수 없습니다',
    noResultsFor: '{{query}}에 대한 결과가 없습니다',
    noFavorites: '아직 즐겨찾기에 추가한 항목이 없습니다.',
    noMessages: '아직 수신한 메시지가 없습니다!',
    resultsFor: '{{query}}에 대한 결과',
    showAll: '모두 표시',
    connectionError: '연결 오류',
    alreadyExists: '이미 존재합니다',
    pageNotFound: '404 페이지를 찾을 수 없습니다!',
    oops: '문제가 발생했습니다...',
    overview: '개요로 돌아가기',
    complete: '계속',
    courseComplete: '완료!',
    chapterComplete: '완료!',
    message: '{count}개의 메시지',
    messagePlural: '{count}개의 메시지',
  },
  itemTypes: {
    image: '이미지',
    brochure: '컬렉션',
    layout: '레이아웃',
    web: '웹사이트',
    pdf: 'PDF',
    carousel: '컬렉션',
  },
  questions: {
    dials: '다이얼을 돌려 답을 맞춰 주세요',
    fitb: '빈칸을 채워 주세요',
    flip: '숫자를 바꿔서 답을 맞춰 주세요',
    multipleChoice: '정답을 선택해 주세요',
    slider: '슬라이더를 사용하여 정답을 선택해 주세요',
    map: '지도에서 올바른 위치를 탭하여 질문에 답해 주세요',
    dropdown: '선택...',
    true: '참',
    false: '거짓',
  },
  reportCard: {
    download: '다운로드',
    email: '이메일',
    print: '출력',
  },
  cookies: {
    consent: '동의',
    optout: '수신 거부',
    settings: '개인 정보 보호 설정',
    message:
      '데이터 개인 정보 기본 설정을 완료하지 않았습니다! 기본 설정을 완료하면 영업 도우미를 사용하여 최고의 경험을 할 수 있습니다.',
    disabled: '쿠키 사용을 비활성화하신 것 같습니다.',
    use: '{{appName}}은(는) 최고의 경험을 제공하기 위해 쿠키를 사용합니다.',
    details: '쿠키는 어디에 사용됩니까?',
    enable: '{{here}}에서 쿠키 활성화 방법을 확인하세요.',
    here: '여기',
  },
  notLoggedIn: {
    super: '로그인하지 않으셨습니다',
    title: '이 콘텐츠를 보려면 로그인해야 합니다',
    guest: '게스트',
  },
  demo: {
    message: '이 웹사이트는 최종 상품의 데모 버전입니다. 이 제품은 현재 개발 중이며 완전한 상품이 아닙니다.',
    consent: '알겠습니다!',
  },
  share: {
    header: '가장 좋아하는 소셜 미디어에 이 자료를 공유해 보세요!',
    download: '다운로드',
  },
  sharing: {
    copyURL: '링크 복사',
    copied: '복사됨',
    email: '이메일',
    download: '다운로드',
  },
  breadCrumbs: {
    page: '페이지',
  },
  onMobile: {
    header: '모바일 장치에서 {appName} 앱에 액세스하시려는 것 같습니다',
    body: '이 프로그램을 다운로드하려면 앱 스토어를 방문하여 {appName}을(를) 검색하거나 아래 버튼 중 하나를 클릭하세요',
    benefits: {
      1: '이동 중 학습, 프로모션, 판매 가능',
      2: '여러 장치를 지원하는 멀티미디어 교육',
      3: '이수 인증서',
      4: '바로 사용할 수 있는 영업 프레젠테이션',
      5: '효과적인 프로모션 자료',
      6: '실시간으로 확인 가능한 상품 안내 자료',
      7: '적시에 관련 소식 및 업데이트 제공',
      header: '제공하는 내용:',
    },
  },
  custom: {
    splitUsers: '저는...',
    brandAmbassador: '브랜드 홍보 대사',
    travelPro: '여행업 종사자',
  },
  rewards: {
    profile: 'Your Profile',
    rewards: 'Rewards',
    title: '보상 센터',
    subheader: 'Prizes / Points / Booking Contest',
    subTitle:
      'We’re giving you a chance to win rewards for becoming a specialist with our program, and booking travel to The Canada!',
    body: 'Book travel to The Canada for your chance to win! Enter your bookings for eligibility to earn an Introductory Incentive Reward of $5 US/CAN E-gift Card.',
    item1:
      'After your first confirmed booking of 4-nights or more, (for an individual reservation), for a minimum of two (2) passengers, at a qualifying hotel/resort. (Cruises do not qualify.)',
    item2: 'Offer valid after Essential Modules of the Canada Specialist Programme Program are completed.',
    link1: 'Have you booked the Canada? ',
    link2: 'If so, submit your booking here.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings Dashboard',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: '성과 대시보드',
    viewRewards: '보상 홈',
    form: 'SUBMIT BOOKING ',
    overview: {
      title: '캐나다 스페셜리스트 리워드 센터에 오신 것을 환영합니다.',
      subtitle: '이 특별 섹션을 사용하여 훈련 진행 상황, 업적, 보상을 추적하세요. ',
      description: '방법은 다음과 같습니다:',
      dashboard: {
        title: '업적 대시보드',
        description:
          '업적 대시보드를 방문하여 교육 진행 상황, 수료증 및 획득한 배지를 추적하세요. 브론즈에서 플래티넘 레벨로 올라갈수록 트래커 바에서 자신의 상태가 어떻게 성장하는지 확인할 수 있습니다.',
        bronze: '브론즈 등급은 파운데이션 챕터를 완료하면 획득할 수 있습니다.',
        silver: '체험 챕터를 완료하면 졸업장과 함께 실버 등급을 획득할 수 있습니다.',
        gold: '골드 상태는 영토/영토/도시 챕터 10개를 완료하면 획득할 수 있습니다.',
        platinum: '플래티넘 등급은 22개 주/영토/도시 챕터를 완료하면 획득할 수 있습니다.',
      },
      platinumRewards: {
        title: '플래티넘 보상',
        description:
          '플래티넘 레벨의 캐나다 스페셜리스트는 여행지 파트너로부터 여행지 체험 패스와 같은 특별 보상을 받을 수 있습니다. 업적 대시보드에서 플래티넘 배지를 받으면 사용 가능한 체험 패스 목록과 교환 지침을 확인할 수 있습니다. 보상을 받으려면 플래티넘 배지를 다운로드하여 목적지 파트너에게 인증용으로 보내야 합니다.',
      },
      downloads: {
        title: '다운로드',
        description:
          '업적 대시보드에서 캐나다 전문가 디플로마, 주/테리토리/시 배지, 금속 상태 배지를 확인하고 다운로드할 수 있습니다. 아이콘을 클릭하여 컴퓨터에 열어 저장하고 고객 및 잠재 고객과 자랑스럽게 공유하세요.',
      },
      termsNotice: {
        start: 'See terms',
        end: 'for more details.',
        link: ' Terms & Conditions ',
      },
      rewards: {
        title: 'Rewards',
        description: {
          start: 'Platinum-level Canada Specialists earn special rewards like',
          end: "from our destination partners. Once you receive your Platinum badge in the Achievements Dashboard, you'll get a list of the available Experience Passes and instructions for redemption.",
          bold: 'Destination Experience Passes',
        },
      },
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'BOOKINGS DASHBOARD',
    },
    leaderboardScreen: {
      title: 'LC POINTS \n Leaderboard',
      earnedpts: 'MY LC POINTS EARNED​:',
      pointsWall: 'LC POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Your Earnings Dashboard',
    },
    bookingForm: {
      title: 'BOOKING CREDIT FORM​',
      subTitle: 'Your Profile',
      required: '* Indicates a required field',
      email: 'Advisor email',
      agentFirstName: 'Advisor First Name',
      agentLastName: 'Advisor Last Name',
      company: 'Agency / Company Name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip / Postal Code',
      country: 'Country',
      city: 'City',
      birthday: 'Birthday',
      type: 'Guest Trip Type',
      source: 'Booking Source',
      tourOperator: 'Tour Operator',
      firstName: 'Guest First Name',
      lastName: 'Guest Last Name',
      confirmNumber: 'Booking Confirm Number',
      file: 'RezSnap™ Proof Upload ',
      arrivalDate: 'Property Arrival Date',
      departureDate: 'Property Departure Date',
      brand: 'LC Brand Booked',
      lengthOfStay: 'Length of Stay (in Nights)',
      cost: 'Total Cost of Booking',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline/ Carrier (2- digit code)',
      gateway: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Canada Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all Bahamas Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within three (3) months of award notification. Any unused, unclaimed or declined awards will be forfeited. Awards will be issued quarterly, and eligibility will be verified based on completed travel.',
      body2:
        'To be eligible you must reside in the U.S or Canada, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Return to landing',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
      link: 'Please note to be a winner, you must have completed the Essential Modules of the Canada Specialist Program',
    },
  },
  badgeView: {
    title: '업적 대시보드',
    subtitle: '디플로마 및 전문성 배지를 보고, 추적하고, 다운로드할 수 있는 업적 대시보드에 오신 것을 환영합니다.',
    viewBadge: '상태 보기',
    badgeDisplayTitle: '성취 상태',
    badgeAchievement: '{rank} 등급을 달성하셨습니다! 아래 배지 아이콘을 클릭하여 등급을 확인하고 공유하세요.',
    badgesCompleteTitle: '전문 분야 배지',
    badgesCompleteSubtitle: '배지를 보고, 저장하고, 공유하려면 아이콘을 클릭하세요.',
    badgesIncompleteSubtitle: '이 챕터를 완료하여 더 많은 배지를 획득하세요.',
    bronze: '브론즈',
    silver: '은',
    gold: '골드',
    platinum: '플래티넘',
    diploma: '디플로마',
    badgeAchievementWithRewards: {
      start: '축하합니다! 플래티넘 등급에 도달하셨습니다. ',
      link: '여기',
      end: ' 플래티넘 등급 보상에 액세스하세요.',
    },
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
